import types from '../../types';

export default {
  [types.STORE_INTERNAL_NOTIFICATIONS]: (state, payload) => {
    state.notifications = {
      items: [...state.notifications.items, ...payload.items],
      count: payload.count,
      pages: payload.pages,
      entity: payload.entity,
    };
  },
  [types.CLEAR_INTERNAL_NOTIFICATIONS]: (state) => {
    state.notifications = {
      items: [],
      count: '',
      pages: null,
      entity: {},
    };
  },
  [types.RESET_NOTIFICATION_COUNT]: (state) => {
    if (state.notifications.entity && state.notifications.entity.total_unread > 0) {
      state.notifications.entity.total_unread = 0;
    }
  },
};
